import type { User } from '@user/models/user.model';
import type { InjectionToken } from 'tsyringe';

export type LoginResult = { token: string; user?: User | null };
export type LoginProviderCallback = (result: LoginResult | null) => void;

export enum LoginProviderType {
  PopUp = 'pop-up',
  Redirect = 'redirect',
}

export type AuthEventCallback = (eventName: string, payload?: unknown) => void;

export interface IAuthService {
  getToken(): Promise<string | null>;
  getUserInfo(): Promise<User | null>;
  initialize(): Promise<void>;
  loginProvider(loginType?: LoginProviderType): Promise<LoginResult | null>;
  logout(loginType?: LoginProviderType): Promise<void>;
  subscribeEvent(callback: AuthEventCallback): VoidFunction;
  subscribeLoginProvider(callback: LoginProviderCallback): Promise<void>;
}

export const AUTH_SERVICE: InjectionToken<IAuthService> = 'AuthService';
